import { produce } from 'immer';
import { StateCreator } from 'zustand';

import { TemplatePermission } from '../models/restrictions.model';
import { IRestrictionsStore } from './restrictions.store';

/**
 * This is the state of the Template slice.
 */
export interface TemplateState {
  permissions: TemplatePermission;
}

/**
 * Actions related to the Template state.
 */
export interface TemplateActions {
  setRestrictions: (permissions: TemplatePermission) => void;
  resetRestrictions: () => void;
}

export type TemplateSlice = {
  template: TemplateState & TemplateActions;
};

/**
 * Creates the Template slice. This function can be merged into
 * a larger store (e.g., a restrictions store).
 */
export const createTemplateSlice: StateCreator<IRestrictionsStore, [], [], TemplateSlice> = (
  set
) => ({
  template: {
    permissions: {} as TemplatePermission,

    setRestrictions: (permissions: TemplatePermission) =>
      set(
        produce((draft: IRestrictionsStore) => {
          draft.template.permissions = permissions;
        })
      ),

    resetRestrictions: () =>
      set(
        produce((draft: IRestrictionsStore) => {
          draft.template.permissions = {} as TemplatePermission;
        })
      ),
  },
});
